"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import type React from "react";
import { createContext, useContext, useState } from "react";
import en from "~/dictionaries/en";
import sv from "~/dictionaries/sv";
interface TranslationContextProps {
  dictionary: Dictionary;
  setLocale: (locale: AppLocale) => void;
  lang: AppLocale; // Added current locale
}
const TranslationContext = createContext<TranslationContextProps>({
  dictionary: {} as Dictionary,
  setLocale: () => {},
  lang: "sv" as AppLocale // Default value
});
type Props = {
  children: React.ReactNode;
};
export default function TranslationProvider(t0) {
  const $ = _c(17);
  const {
    children
  } = t0;
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [dictionary, setDictionary] = useState(t1 as Dictionary);
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[1] !== dictionary || $[2] !== pathName || $[3] !== router || $[4] !== searchParams) {
    const setLocale = locale => {
      const newDictionary = locale === "sv" ? sv : en;
      setDictionary(newDictionary);
      const newPath = pathName.startsWith(`/${getCurrentLocale()}`) ? pathName.replace(`/${getCurrentLocale()}`, `/${locale}`) : `/${locale}${pathName}`;
      const searchParamsString = searchParams.toString();
      const newUrl = searchParamsString ? `${newPath}?${searchParamsString}` : newPath;
      router.push(newUrl);
    };
    const getCurrentLocale = () => {
      const loc = pathName.split("/");
      const locale_0 = loc.length > 1 ? loc[1] : "sv";
      return locale_0 === "en" ? "en" : "sv";
    };
    T0 = TranslationContext.Provider;
    t2 = dictionary;
    t3 = setLocale;
    t4 = getCurrentLocale();
    $[1] = dictionary;
    $[2] = pathName;
    $[3] = router;
    $[4] = searchParams;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      dictionary: t2,
      setLocale: t3,
      lang: t4
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== T0 || $[14] !== children || $[15] !== t5) {
    t6 = <T0 value={t5}>{children}</T0>;
    $[13] = T0;
    $[14] = children;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
export const useTranslation = () => {
  const context = useContext(TranslationContext);
  return context;
};